import React from "react";
import DividerGrid from "./DividerGrid";

function BundlePrice({
  title,
  desc,
  duration,
  singlePrice,
  bundlePrice,
  bundleDesc,
  details,
  cols,
  color,
}) {
  return (
    <div className="col">
      <div
        className={`card mb-4 rounded-3 shadow-sm border-${color} fit-height`}
      >
        <div className={`card-header py-3 bg-${color} border-${color}`}>
          <h4 className="my-0 fw-normal quint">{title}</h4>
        </div>
        <div
          className={`card-body bg-${color}-light rounded-bottom-3 pt-0 pt-sm-2 pt-md-0 pt-lg-2 pt-xl-0`}
        >
          <div className="container-fluid pricing-card-details pb-2">
            <DividerGrid cols={cols}>
              <div
                className={`col mx-auto d-flex align-items-center justify-content-center border-${color}`}
              >
                <div className="row justify-content-center align-items-center row-cols-1 mb-1">
                  <div className="col bundle-desc">
                    <h2 className="pricing-card-title">{desc}</h2>
                  </div>
                  <hr
                    className={`bundle-hr border-${color} mb-2 price-divider`}
                  />
                  <div className="col col-auto">
                    <h1
                      className={`card-title pricing-card-title bg-${color} px-3 py-1 my-auto rounded-2`}
                    >
                      {duration} perces kezelés
                    </h1>
                  </div>
                  <div className="col col-xl-auto">
                    <h1 className="card-title pricing-card-title">
                      {singlePrice} Ft
                      <small className="text-body-secondary fw-light">
                        /alkalom
                      </small>
                    </h1>
                  </div>
                  <div className="col col-xl-auto">
                    <h1 className="card-title pricing-card-title">
                      {bundlePrice} Ft
                      <small className="text-body-secondary fw-light">
                        {bundleDesc}
                      </small>
                    </h1>
                  </div>
                </div>
              </div>
              <hr
                className={`bundle-hr border-${color} h-divider`}
              />
              {details &&
                details.map((detail, i) => (
                <React.Fragment key={i}>
                    <div className={`col mx-auto border-${color}`}>
                      <h1 className="card-title pricing-card-title">
                        {detail.title}
                      </h1>
                      {detail.secondaryTitle && (
                        <h2 className="pricing-card-title text-start">
                          {detail.secondaryTitle}
                        </h2>
                      )}
                      <ul className="text-start mb-0">
                        {detail.listItems.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    </div>
                    <hr className={`bundle-hr border-${color} mt-2 h-divider`} />
                  </React.Fragment>
                ))}
            </DividerGrid>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BundlePrice;
